import React from 'react';
import {
  ModalFloatingCloseBtn,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import { AddressForm } from '../../components/Address';
import { useAddressHandlers } from '../../components/Address/Address.hooks';
import { PageWrapper } from '../../components/PageWrapper';
import { TransparentModal } from '../../components/TransparentModal';
import type { AddressAddScreenProps } from '../../navigation/AppNavigation.props';

export const AddressAddScreen = ({
  navigation,
}: AddressAddScreenProps): React.ReactElement => {
  const { t } = useLocalizationContext();

  const handleGoBack = React.useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.getParent()?.goBack();
    }
  }, [navigation]);

  const {
    addAddressResponse: { fetching: isAddingAddress },
    handleOnSave,
    handleOnClose,
    handleOnEdit,
    handleOnDelete,
  } = useAddressHandlers({ checkExistingBag: true, onClose: handleGoBack });

  const { isMobile } = useBreakpointHelpers();

  return (
    <TransparentModal size="small" onClose={handleOnClose}>
      {isMobile ? null : <ModalFloatingCloseBtn onPress={handleOnClose} />}
      <PageWrapper
        withHeaderTitle
        withoutFooter
        testID="account.add-address.root.container"
      >
        <AddressForm
          address={undefined}
          visible={true}
          editing={false}
          loading={isAddingAddress}
          deleting={false}
          noHeader={false}
          disableAddress={false}
          submitCta={t('account.addresses.save')}
          onSave={handleOnSave}
          onEdit={handleOnEdit}
          onDelete={handleOnDelete}
        />
      </PageWrapper>
    </TransparentModal>
  );
};
